import { render, staticRenderFns } from "./PonitAdd.vue?vue&type=template&id=2402cd48&scoped=true&"
import script from "./PonitAdd.vue?vue&type=script&lang=js&"
export * from "./PonitAdd.vue?vue&type=script&lang=js&"
import style0 from "./PonitAdd.vue?vue&type=style&index=0&id=2402cd48&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402cd48",
  null
  
)

export default component.exports